import { Box, useTheme } from '@mui/material';
import { type PropsWithChildren } from 'react';

const MAX_WIDTH = 1808;

export const StyledPageTabContent = ({ children }: PropsWithChildren) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        width: '100%',
        height: '100%',
        padding: theme.spacing(2),
        gap: theme.spacing(10),
        maxWidth: MAX_WIDTH,
      }}
    >
      {children}
    </Box>
  );
};
